import React from "react";
import {PromoDto, SaleTypeDto} from "../../../dtos";
import {PromoSaleType} from "./PromoSaleType/PromoSaleType";
import styles from './PromosSaleTypesPopup.module.scss'
import {saleTypesDropdownData} from "../../../globals/Contants";
import {ReactComponent as CloseIcon} from "../../../assets/editors/close_icon_x.svg";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {convertPromoPropertiesToGenericParams} from "../../../globals/PromoSaleTypeCaptionGenerator";


interface Props {
    saleTypesArray: SaleTypeDto[];
    selectedSaleType: SaleTypeDto;
    setSelectedSaleType: (saleType: SaleTypeDto) => void;
    currentPromoSaleTypeCode?: number;
    openSaleTypesDropdown: (value: boolean) => void;
    promotionState: PromoDto;
    defaultPromotionState: PromoDto;
}



export const PromosSaleTypesPopup: React.FC<Props> = (
    {
        saleTypesArray,
        selectedSaleType,
        setSelectedSaleType,
        currentPromoSaleTypeCode,
        openSaleTypesDropdown,
        promotionState,
        defaultPromotionState
    }
) => {
    const saleTypes = saleTypesArray.map((saleType: SaleTypeDto, index) => {
        const selectedPatternSaleType = saleTypesDropdownData.find((key) => key.saleTypeId === saleType.satCode);
        if(selectedPatternSaleType) {
            const selectedId = selectedSaleType.satCode? selectedSaleType.satCode : currentPromoSaleTypeCode;
            let selected: boolean = selectedId === saleType.satCode;
            const saleTypeDefaultState = selected ? promotionState : defaultPromotionState;
            let convertValuesForBenefitAndRequisite = convertPromoPropertiesToGenericParams(saleTypeDefaultState, saleType);
            let saleTypeObj = {...saleType};
            if(selected || selectedPatternSaleType.saleTypeId === saleTypeDefaultState.flrSatCode){
                saleTypeObj = {
                    ...saleType,
                    requisite: convertValuesForBenefitAndRequisite.requisite,
                    benefit: convertValuesForBenefitAndRequisite.benefit,
                }
            }
            let requisiteMaxValue = 0;
            let requisiteMinValue = 0;
            if(selectedPatternSaleType.saleTypeId === 13){
                requisiteMaxValue = 100;
                requisiteMinValue = 0;
            }
            return <PromoSaleType
                key={index}
                saleType={saleTypeObj}
                defaultSaleType={selectedPatternSaleType}
                isSelected={selected}
                setSelectedSaleTypeData={setSelectedSaleType}
                requisiteMaxValue={requisiteMaxValue}
                requisiteMinValue={requisiteMinValue}
            />
        }
    })

    const handleClose = () => {
        openSaleTypesDropdown(false);
    }
    return (
        <ClickAwayListener onClickAway={handleClose}>
            <div className={styles.sale_types_popup}>
                <table className={styles.sale_types_table}>
                    <thead className={styles.header_sale_types_popup}>
                    <tr>
                        <th>Sticker</th>
                        <th>Promo Type Code</th>
                        <th>Promo Type Label</th>
                        <th>Requisite</th>
                        <th>Benefit
                            <div className={styles.close_icon} onClick={() => {
                                openSaleTypesDropdown(false);
                            }}>
                                <CloseIcon/>
                            </div>

                        </th>
                    </tr>
                    </thead>
                    <tbody className={styles.content_sale_types}>
                    {saleTypes}
                    </tbody>
                </table>
            </div>
        </ClickAwayListener>
    )
}